export default __webpack_public_path__ + "static/media/internet-find-home.caee1dbf.png";